import { render } from "./AppCucumber.vue?vue&type=template&id=46d4cd88"
import script from "./AppCucumber.vue?vue&type=script&lang=js"
export * from "./AppCucumber.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__